import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import Chart from 'chart.js/auto';

import ChartWidgetCreator from './ChartWidgetCreator';
import ChartWidgetEditor from './ChartWidgetEditor';
import { API_BASE_URL, ItemList, renderModal, closeModal, renderConfirmationModal, handleDelete, handleDuplicate, fetchData, LoadingOverlay, ChartWidget, Breadcrumbs } from './Common';

function Project() {
  const { projectId } = useParams();
  const [tables, setTables] = useState([]);
  const [tableColumnData, setTableColumnData] = useState([]);
  const [isTableColumnDataLoaded, setIsTableColumnDataLoaded] = useState(false);
  const [isTablesLoaded, setIsTablesLoaded] = useState(false);

  const [isDuplicating, setIsDuplicating] = useState(false); // State variable to
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');
  const [modalMessageColor, setModalMessageColor] = useState('');
  const [widgetToDelete, setWidgetToDelete] = useState(null);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const [widgets, setWidgets] = useState([]);
  const [isWidgetsLoaded, setIsWidgetsLoaded] = useState(false);
  const [modalIconId, setModalIconId] = useState(0);

  const [showChartWidgetCreator, setShowChartWidgetCreator] = useState(false);
  const [selectedWidgetId, setSelectedWidgetId] = useState(null);
  const [viewWidgetId, setviewWidgetId] = useState(null);

  const [currentPage, setCurrentPage] = useState(1); // Track current page number
  const itemsPerPage = 10; // Maximum items per page

  const [projectName, setProjectName] = useState('');
  const [isProjectNameLoaded, setIsProjectNameLoaded] = useState(false);

  const handleWidgetCreated = () => {
  setShowChartWidgetCreator(false);

  setModalMessage("Widget criado!");
  setModalMessageColor('#41BBC9');
  setModalIconId(1);
  setIsModalOpen(true);
};

  useEffect(() => {

    fetchData(`${API_BASE_URL}/project/${projectId}`, setProjectName, setIsProjectNameLoaded, 'name');

    fetchData(`${API_BASE_URL}/tables/${projectId}`, setTables, setIsTablesLoaded, 'tables');

    fetchData(`${API_BASE_URL}/column-data/${projectId}`, setTableColumnData, setIsTableColumnDataLoaded, 'columnData');

    fetchData(`${API_BASE_URL}/widgets/${projectId}`, setWidgets, setIsWidgetsLoaded, 'widgetData');
  }, [projectId]); // Include projectId in the dependency array to refetch tables when projectId changes

const handleDuplicateWidget = (widgetId) => {
    handleDuplicate(
      'widget',
      widgetId,
      setWidgets,
      widgets,
      'Widget Duplicado!',
      setIsDuplicating,
      setModalMessage,
      setModalMessageColor,
      setIsModalOpen
    );
  };

const handleButtonClick = () => {
  if(selectedWidgetId) setSelectedWidgetId (null);
  else if(viewWidgetId) setviewWidgetId (null);
  else setShowChartWidgetCreator(prevState => !prevState); // Invert the state to show/hide ChartWidgetCreator
};

const confirmDeleteWidget = async () => {
  setviewWidgetId(null);
  setModalIconId(0);
        const token = localStorage.getItem('token');
        await handleDelete('widgets', null, widgetToDelete, token, setWidgets, widgets, setModalMessage, setModalMessageColor, setIsModalOpen, currentPage, setCurrentPage, itemsPerPage);
        setIsConfirmationModalOpen(false);
    };

const handleDeleteClick = (widgetId) => {
        setWidgetToDelete(widgetId);
        setIsConfirmationModalOpen(true);
    };

const hasReadOnlyPermission = Object.values(tables).some(table => table.permission === 'read-only');

const nonElementWidgets = Object.keys(widgets)
    .filter(key => widgets[key].label_id !== 0)
    .reduce((result, key) => {
        result[key] = widgets[key];
        return result;
    }, {});

  return (
  <div className="home-container">

  <Breadcrumbs
  items={
    viewWidgetId
      ? [
          { label: "Projetos", path: "/home" },
          { label: projectName, path: `/project/${projectId}/dados` },
          { label: "Widgets", onClick: () => setviewWidgetId(null) },
          { label: widgets[viewWidgetId]?.name || "Widget" },
        ]
      : selectedWidgetId || showChartWidgetCreator
      ? [
          { label: "Projetos", path: "/home" },
          { label: projectName, path: `/project/${projectId}/dados` },
          {
            label: "Widgets",
            onClick: () => {
              setSelectedWidgetId(null);
              setShowChartWidgetCreator(false);
            },
          },
          { label: selectedWidgetId ? "Editar Widget" : "Criar Widget" },
        ]
      : [
          { label: "Projetos", path: "/home" },
          { label: projectName, path: `/project/${projectId}/dados` },
          { label: "Widgets" },
        ]
  }
/>


  {!showChartWidgetCreator && !viewWidgetId && !selectedWidgetId && (<>

    <p className="text0">Gerir widgets</p>
    <p>Acesso à lista de todos os widgets do projeto</p>
    <p className="text1">{projectName}</p>

<ItemList
      tipo="widget"
      isLoaded={isTableColumnDataLoaded}
      onView={setviewWidgetId}
      onEdit={setSelectedWidgetId}
      onDelete={handleDeleteClick}
      onDuplicate={handleDuplicateWidget}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        DataArray={nonElementWidgets}
        itemsPerPage={itemsPerPage}
      />
</>)}

{renderConfirmationModal(isConfirmationModalOpen, "Tem a certeza que pretende eliminar o widget?", confirmDeleteWidget, () => setIsConfirmationModalOpen(false))}

{renderModal(isModalOpen, modalMessage, closeModal(setIsModalOpen), modalMessageColor, modalIconId)}

<div>

<div className="button-container">
<button
  className="button"
  onClick={() => {
    if (!isTablesLoaded || (hasReadOnlyPermission && !viewWidgetId && !selectedWidgetId && !showChartWidgetCreator)) {
      return; // Prevent any action if tables are not loaded or in read-only mode
    }
    handleButtonClick();
  }}
  style={{
    cursor: !isTablesLoaded || (hasReadOnlyPermission && !viewWidgetId && !selectedWidgetId && !showChartWidgetCreator) ? 'not-allowed' : 'pointer',
    opacity: !isTablesLoaded || (hasReadOnlyPermission && !viewWidgetId && !selectedWidgetId && !showChartWidgetCreator) ? 0.5 : 1,
  }}
  disabled={!isTablesLoaded || (hasReadOnlyPermission && !viewWidgetId && !selectedWidgetId && !showChartWidgetCreator)} // Disable button if tables are not loaded or in read-only mode
>
  {(viewWidgetId || selectedWidgetId || showChartWidgetCreator) ? 'Voltar' : 'Criar widget'}
</button>

   </div>

{!selectedWidgetId && viewWidgetId && (

<div className="home-container" style={{ paddingLeft: '0px', paddingTop: '10px' }}>
      <p className="text0">{{[viewWidgetId] : widgets[viewWidgetId]}[Object.keys({[viewWidgetId] : widgets[viewWidgetId]})[0]].name}</p>

<ChartWidget
  tableColumnData={tableColumnData}
  widget={{[viewWidgetId] : widgets[viewWidgetId]}}
  tables={tables}
/>

</div>
)}

{selectedWidgetId && (
      <ChartWidgetEditor
        widget={{[selectedWidgetId] : widgets[selectedWidgetId]}}
        tableColumnData={tableColumnData}
        isTablesLoaded={isTablesLoaded}
        tables={tables}
        projectId={projectId}
        setWidgets={setWidgets}
      />
)}

{showChartWidgetCreator && (
      <ChartWidgetCreator
        tableColumnData={tableColumnData}
        isTablesLoaded={isTablesLoaded}
        tables={tables}
        projectId={projectId}
        setWidgets={setWidgets}
        onWidgetCreated={handleWidgetCreated}
      />
)}

</div>

<LoadingOverlay isDuplicating={isDuplicating} />

</div>
);

}

export default Project;
